import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-16">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <h1
          className="text-5xl md:text-6xl font-light text-center mb-4 text-[#5C2018]"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
          data-testid="contact-title"
        >
          Nous Contacter
        </h1>
        <p className="text-center text-[#332724] font-light mb-16 max-w-2xl mx-auto">
          Venez nous rendre visite au Polygone de Béziers ou contactez-nous pour plus
          d'informations.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <div className="bg-white p-8 rounded-lg border border-gold shadow-[0_8px_32px_rgba(92, 32, 24,0.05)] mb-8">
              <h2
                className="text-3xl mb-6 text-[#5C2018]"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
              >
                Informations
              </h2>

              <div className="space-y-6">
                <div className="flex items-start gap-4" data-testid="contact-address">
                  <div className="w-12 h-12 bg-[#1E7A6A]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-[#1E7A6A]" size={24} />
                  </div>
                  <div>
                    <h3 className="font-medium mb-1 text-[#332724]">Adresse</h3>
                    <p className="text-[#332724] font-light">
                      3 Carrefour de l'Hours
                      <br />
                      Niveau Écluses
                      <br />
                      Polygone de Béziers
                      <br />
                      34500 Béziers
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-testid="contact-phone">
                  <div className="w-12 h-12 bg-[#B8922A]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="text-[#B8922A]" size={24} />
                  </div>
                  <div>
                    <h3 className="font-medium mb-1 text-[#332724]">Téléphone</h3>
                    <a
                      href="tel:0467215708"
                      className="text-[#332724] font-light hover:text-[#1E7A6A] transition-colors"
                    >
                      04 67 21 57 08
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-testid="contact-email">
                  <div className="w-12 h-12 bg-[#5C2018]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="text-[#5C2018]" size={24} />
                  </div>
                  <div>
                    <h3 className="font-medium mb-1 text-[#332724]">Email</h3>
                    <p className="text-[#332724] font-light">contact@maisonharmony.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-testid="contact-hours">
                  <div className="w-12 h-12 bg-[#1E7A6A]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock className="text-[#1E7A6A]" size={24} />
                  </div>
                  <div>
                    <h3 className="font-medium mb-1 text-[#332724]">Horaires</h3>
                    <p className="text-[#332724] font-light">
                      Lundi - Samedi: 10h - 20h
                      <br />
                      <span className="text-[#332724]/70">Fermé le dimanche</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Boutique Image */}
            <div className="h-64 rounded-lg overflow-hidden">
              <img
                src="/assets/boutique_1.jpg"
                alt="Boutique Harmony Parfumerie au Polygone de Béziers"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Map */}
          <div className="bg-white p-2 rounded-lg border border-gold shadow-[0_8px_32px_rgba(92, 32, 24,0.05)]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2893.6!2d3.2303!3d43.3442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b134e7f7f7f7f7%3A0x1234567890!2sPolygone%20B%C3%A9ziers!5e0!3m2!1sfr!2sfr!4v1234567890"
              width="100%"
              height="600"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Carte Harmony Parfumerie"
              data-testid="contact-map"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
